import { useMutation } from 'react-query'
import { postAPI } from 'framework/api/http'

interface CreateInboundOrderCutoffTimeImeInterface {
  partnerCode?: string
  partnerName?: string
  integrationType?: string
  integrationId?: string
  integrationURL?: string
  criteria?: string
  containerTypes?: string
  numberOfLines?: number
  inboundCutOffLeadTime?: number
  isActive: boolean
}
export const useCreateInboundOrderCutoffTime = () => {
  const mutate = useMutation(
    ({
      partnerCode,
      partnerName,
      integrationType,
      integrationId,
      integrationURL,
      criteria,
      containerTypes,
      numberOfLines,
      inboundCutOffLeadTime,
      isActive,
    }: CreateInboundOrderCutoffTimeImeInterface) => {
      return postAPI('/CreateInbdOrderCutoffTime', {
        partnerCode,
        partnerName,
        integrationType,
        integrationId,
        integrationURL,
        criteria,
        containerTypes,
        numberOfLines,
        inboundCutOffLeadTime,
        isActive,
      })
    },
  )
  return mutate
}
export default useCreateInboundOrderCutoffTime
